module.exports = __webpack_public_path__ + "assets/c4c8f4c66a7c5bbb5158b3541552dcce.mp3";